var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2021/FormIcon - Search ALt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2021/FormIcon---Search-ALt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_search",
    transform: "translate(12.279726, 12.463361)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7547571,0 C8.47310813,-0.0199745372 4.98370344,3.43055099 4.9557916,7.712156 C4.95780654,9.51599777 5.59924669,11.260715 6.76613643,12.6362939 L0.248895049,19.0883629 C0.0896757305,19.2449197 0,19.4588606 0,19.682156 C0,19.9054514 0.0896757305,20.1193923 0.248895049,20.2759491 C0.408578304,20.4346023 0.624832888,20.5231885 0.849929532,20.5221649 C1.07487155,20.5223972 1.29083583,20.4339299 1.45096401,20.2759491 L7.96820539,13.7587077 L8.04061919,13.8238801 C10.3906962,15.5859045 13.5314527,15.8780936 16.1662339,14.5798178 C18.8010151,13.281542 20.482896,10.6130214 20.5175157,7.67594911 C20.4699014,3.42266962 17.0083031,0 12.7547571,0 Z M12.7547571,13.7587788 C9.42805839,13.722806 6.75690448,11.0032243 6.78077465,7.67641751 C6.80464482,4.3496107 9.51454823,1.66863863 12.8414196,1.68043788 C16.168291,1.69231523 18.8590462,4.39250494 18.8592399,7.71939738 C18.8392982,11.0719951 16.1073757,13.7747511 12.7547571,13.7587788 Z",
    id: "Shape",
    transform: "translate(10.258758, 10.261082) scale(-1, 1) translate(-10.258758, -10.261082) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d8293101.svg";
export { ForwardRef as ReactComponent };